import React, { useEffect, useState } from "react";
import styles from "./ClassTimeTable.module.css";
import { EditableProTable } from "@ant-design/pro-components";
import { Button, Select } from "antd";

const ClassTimeTable = ({ value, setValue, disabled }) => {
  const [dataSource, setDataSource] = useState(value ? value : []);
  const initialValue = value;
  const [editableKeys, setEditableRowKeys] = useState();
  useEffect(() => {
    setValue(dataSource);
  }, [dataSource, setValue]);
  useEffect(() => {
    if (Array.isArray(initialValue)) {
      const givenDataId = initialValue.map((el, index) => {
        return { id: index, ...el };
      });
      setDataSource(givenDataId);
    }
  }, [disabled]);
  const onDelete = (id) => {
    const newData = dataSource.filter((item) => item.id !== id);
    setDataSource(newData);
  };

  const columns = [
    {
      title: "روز",
      dataIndex: "day",
      width: "40%",
      editable: true,
      align: "center",
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          return (
            <Select>
              {[
                "شنبه‌ها",
                "یکشنبه‌ها",
                "دوشنبه‌ها",
                "سه‌شنبه‌ها",
                "چهارشنبه‌ها",
                "پنج‌شنبه‌ها",
                "جمعه‌ها",
              ].map((el) => {
                return (
                  <Select.Option value={el} key={el}>
                    {el}
                  </Select.Option>
                );
              })}
            </Select>
          );
        }
      },
      render: (text, row) => <div>{text}</div>,
    },
    {
      title: "ساعت",
      dataIndex: "time",
      width: "40%",
      editable: true,
      align: "center",
    },
    {
      title: "عملیات",
      valueType: "option",
      key: "option",
      align: "center",

      render: (text, record, _, action) => {
        const button = (
          <Button
            key="editable"
            onClick={() => {
              action.startEditable(record.id);
            }}
          >
            ویرایش
          </Button>
        );
        return [button];
      },
    },
  ];

  const onSave = (row) => {
    const newData = [...dataSource];
    const index = newData.findIndex((item) => row.id === item.id);
    const item = newData[index];
    newData.splice(index, 1, { ...item, ...row });
    setDataSource(newData);
  };

  return (
    <div className={styles.ClassTimeTable}>
      <EditableProTable
        rowKey="id"
        recordCreatorProps={{
          position: "bottom",
          record: (index) => {
            return {
              id: index + 1,
              day: "شنبه‌ها",
              time: "12:00 تا 12:00",
            };
          },
        }}
        columns={columns}
        value={dataSource}
        onChange={setDataSource}
        editable={{
          actionRender: (row, config, dom) => [
            dom.save,
            // dom.cancel,
            dom.delete,
          ],
          onSave: async (rowKey, data, row) => {
            onSave ? onSave(row, data) : console.log("");
          },
          onCancel: async (rowKey, data, row) => {
            // onSave ? onCancel(row , data) : console.log('');
          },
          onDelete: async (rowKey, data, row) => {
            if (onSave) {
              onDelete(row, data);
            }
          },
          // type: 'multiple',
          onlyAddOneLineAlertMessage: ".شما درحال اضافه کردن سطر جدید هستید",
          deletePopconfirmMessage: "مطمئن هستید میخواهید این سطر را حذف کنید؟",
          onlyOneLineEditorAlertMessage: ".شما در حال ویرایش سطر دیگری هستید ",
          onChange: setEditableRowKeys,
          editableKeys,
        }}
      />
    </div>
  );
};

export default ClassTimeTable;
